import React, { ReactNode } from "react";

interface BackgroundCardProps {
  children?: ReactNode;
}

const BackgroundCard: React.FC<BackgroundCardProps> = ({ children }) => {
  return (
    <div className="bg-[url('/src/assets/images/overlay.png')] bg-cover bg-center bg-no-repeat w-full h-screen  flex items-center justify-center">
      {children}
    </div>
  );
};

export default BackgroundCard;
